import './SocialMediaButtons.css';

export default function SocialMediaButtons({ color }) {
    return (
        <div className="footer-socials">
            {/* LinkedIn */}
            <a
                href="https://www.linkedin.com/company/aivhy"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
            >
                <svg width="22" height="22" fill={color} viewBox="0 0 24 24">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-10h3v10zm-1.5-11.268c-.966 0-1.75-.784-1.75-1.75s.784-1.75 1.75-1.75 1.75.784 1.75 1.75-.784 1.75-1.75 1.75zm13.5 11.268h-3v-5.604c0-1.337-.025-3.063-1.868-3.063-1.868 0-2.154 1.459-2.154 2.968v5.699h-3v-10h2.881v1.367h.041c.401-.761 1.379-1.563 2.838-1.563 3.036 0 3.6 2.001 3.6 4.601v5.595z" />
                </svg>
            </a>

            {/* Facebook */}
            <a
                href="https://www.facebook.com/AIVHY.OT/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
            >
                <svg width="22" height="22" fill={color} viewBox="0 0 24 24">
                    <path d="M22.675 0h-21.35C.6 0 0 .6 0 1.325v21.351C0 23.4.6 24 1.325 24h11.495v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.894-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.796.715-1.796 1.763v2.313h3.591l-.467 3.622h-3.124V24h6.127C23.4 24 24 23.4 24 22.675V1.325C24 .6 23.4 0 22.675 0z" />
                </svg>
            </a>
        </div>
    );
}